import Content from "../../help/lot-affected-units.mdx";

export function LotAffectedUnitsHelpPage() {
  return <Content />;
}
